const rail = ($container = $('body')) => {
  const $footer = $container.find('@footer');
  const $header = $container.find('@header');
  const $rail = $container.find('@main');
  const $window = $(window);

  const $railIsPresent = $rail.length > 0;

  if ($railIsPresent) {
    $window.on('ready resize', () => {
      init();
    });
  }

  function init() {
    const $headerHeight = $header.innerHeight();
    const $footerHeight = $footer.innerHeight();
    const $windowHeight = $window.height();
    const $windowWidth = $window.width();
    const breakpoint = 768;
    const offset = 3;

    const $railHeight = $windowHeight - ($headerHeight + $footerHeight);

    if ($windowWidth <= 768) {
      $rail.css({ 'min-height': $railHeight + offset });
    } else {
      $rail.css({ 'min-height': 'auto' });
    };
  }
};

export default rail;
